module.exports = __webpack_public_path__ + "img/Weapon_71.06ce52bc.png";